var baseConfig = {
  "version": "1.14.1",
  "buildTime": "Wed Jan 31 2024 8:49",
  "name": {
    "file": {
      "index": "index.html",
      "config": "app.config.js",
      "baseConfig": "base.config.js",
      "sass": "app.scss",
      "style": "app.css",
      "appScript": "app*.js",
      "appTemplate": "index.html",
      "favicon": "favicon.ico"
    },
    "dir": {
      "tmp": ".tmp",
      "server": "server",
      "raw": "raw",
      "client": "client",
      "dist": "dist",
      "vendors": "vendors",
      "logs": "logs",
      "db": "db",
      "build": "build",
      "app": "app",
      "config": "config",
      "assets": "assets",
      "locales": "locales",
      "tests": "tests",
      "api": "api",
      "libs": "libs",
      "serverVendors": "node_modules",
      "sass": "sass",
      "styles": "styles",
      "images": "img",
      "pictures": "pics",
      "fonts": "fonts",
      "projectSass": "app",
      "vicAssets": "vic-assets",
      "vicStyles": "vic-styles",
      "components": "components",
      "data": "data",
      "controllers": "controllers",
      "directives": "directives",
      "scripts": "scripts",
      "utils": "utils",
      "services": "services",
      "views": "views",
      "models": "models",
      "layouts": "layouts",
      "shared": "shared",
      "optimised": "optimised",
      "public": "public"
    }
  },
  "envName": "prod",
  "env": {
    "protocol": "both",
    "hostname": "www.wgtn.ac.nz",
    "port": 80,
    "basePath": "/explore/",
    "db": {
      "host": null,
      "port": null,
      "name": null,
      "options": {}
    },
    "urls": {
      "staticAssets": "https://www.wgtn.ac.nz/__data/assets/git_bridge/0005/1778018/dist/",
      "website": "https://www.wgtn.ac.nz",
      "websiteStage": "https://cms.wgtn.ac.nz",
      "international": "https://service-web.wgtn.ac.nz"
    },
    "debug": "debug"
  },
  "productionReady": true,
  "path": {
    "file": {
      "index": "../index.html",
      "favicon": "../favicon.ico",
      "sass": "../assets/sass/app.scss",
      "style": "../assets/styles/app.css",
      "config": "../app/config/app.config.js",
      "baseConfig": "../app/config/base.config.js",
      "appScript": "../app/app*.js"
    },
    "dir": {
      "root": "..",
      "config": "../app/config",
      "app": "../app",
      "assets": "../assets",
      "tests": "../tests",
      "vendors": "../vendors",
      "vicAssets": "../vendors/vic-assets",
      "vicStyles": "../assets/sass/libs/vic-styles",
      "styles": "../assets/styles",
      "sass": "../assets/sass",
      "images": "../assets/img",
      "pictures": "../assets/pics",
      "fonts": "../assets/fonts",
      "shared": "../assets/shared",
      "sassLibs": "../assets/sass/libs",
      "projectSass": "../assets/sass/app",
      "components": "../app/components",
      "scripts": "../app/scripts",
      "utils": "../app/utils",
      "views": "../app/views",
      "data": "../app/data"
    }
  }
}
;